import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { ComponentModel } from 'src/app/models/maintenance/component.model';
import { ElementModel } from 'src/app/models/maintenance/element.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ElementService } from 'src/app/services/maintenance/element.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterElementComponent } from '../register-element/register-element.component';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-element',
  templateUrl: './element.component.html',
  styleUrls: ['./element.component.scss'],
  standalone: false
})
export class ElementComponent implements OnInit {
  private readonly elementService = inject(ElementService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly toastHandlerService = inject(ToastHandlerService);

  @ViewChild('elementModal') elementModalComponent?: CustomModalComponent | null = null;
  @Input('componentModel') set changeDate(change: ComponentModel) {
    this.changeComponent(change);
  }
  @Input() permissionUpdatable: boolean = false;
  @Input() active: boolean = false;
  @Output() emitSelectedElement = new EventEmitter<ElementModel>();


  componentModel: ComponentModel = new ComponentModel();
  elementRegisterModal = RegisterElementComponent;
  elements: ElementModel[] = [];
  inputsForRegister$ = new BehaviorSubject<any>({
    elementModel: new ElementModel(),
    componentModel: new ComponentModel(),
    active: false
  });
  output$ = new Subject<any>();
  selectedElement: ElementModel = new ElementModel();
  subscription: Subscription;

  constructor() { }

  ngOnInit() {
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onReload':
          this.reloadList(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  changeComponent(change: ComponentModel) {
    this.componentModel = change;
    if (this.componentModel.componentId != 0) {
      this.getElementsByComponentId();
    } else {
      this.elements = [];
    }
    this.selectedElement = new ElementModel();
  }

  elementSelected(selectedElement: ElementModel) {
    this.selectedElement = selectedElement;
    this.emitSelectedElement.emit(selectedElement);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar elementos.
            Comuníquese con el administrador del sistema.`);
      return;
    } else if (!this.selectedElement || this.selectedElement.elementId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una seleccionar un elemento.');
      return;
    } else if (this.active) {
      this.toastHandlerService.showToast('error', 'No es posible eliminar, la rutina de mantenimiento se encuentra cerrada.', 'Atención');
      return;
    }

    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar el elemento?');
    if (accepted) {
      try {
        await firstValueFrom(this.elementService.deleteElement(this.selectedElement.elementId));
        this.selectedElement = new ElementModel();
        await this.getElementsByComponentId();
        this.toastHandlerService.showToast('success', 'El elemento fue eliminado exitosamente.');
      } catch (error) {
        console.error('Error al eliminar el elemento.', error);
      }
    }
  }

  async getElementsByComponentId() {
    try {
      const response = await firstValueFrom(this.elementService.getElementsByComponentIdAsync(this.componentModel.componentId));
      this.elements = response;
      // this.selectedElement = new ElementModel();
    } catch (error) {
      console.error('Error al obtener lo elementos por id.', error);
    }
  }

  newElement() {
    if (this.componentModel.componentId == 0) {
      this.toastHandlerService.showToast('warning', `Debe seleccionar un componente.`, 'Atención.');
      return;
    } else if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para crear elementos.
            Comuníquese con el administrador del sistema.`);
      return;
    }

    this.inputsForRegister$.next({
      elementModel: this.selectedElement,
      componentModel: this.componentModel
    });
    this.elementModalComponent?.show();
  }

  async reloadList(reload: boolean) {
    if (reload) {
      await this.getElementsByComponentId();
    }
  }
}
